@if (variant() === 'primary') {
  <button
    mat-raised-button
    class="btn-primary"
    [type]="type()"
    (click)="onClick()"
  >
    {{ label() }}
    @if (icon()) {
      <mat-icon>{{ icon() }}</mat-icon>
    }
  </button>
} @else {
  <button
    mat-stroked-button
    class="btn-secondary"
    [type]="type()"
    (click)="onClick()"
  >
    {{ label() }}
    @if (icon()) {
      <mat-icon>{{ icon() }}</mat-icon>
    }
  </button>
}
